import React from "react";

const PlayerRepImg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 397 271.451"
      >
        <g id="playerRep" transform="translate(-160 -1463)">
          <g id="undraw_profile_6l1l" transform="translate(160 1463)">
            <line
              id="Line_6"
              data-name="Line 6"
              x2="63.931"
              transform="translate(0 270.951)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <rect
              id="Rectangle_10"
              data-name="Rectangle 10"
              width="283.839"
              height="182.4"
              rx="19.398"
              transform="translate(93.586 46.698)"
              fill="#f2f2f2"
            />
            <rect
              id="Rectangle_11"
              data-name="Rectangle 11"
              width="283.839"
              height="182.4"
              rx="19.398"
              transform="translate(84.921 35.183)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_7"
              data-name="Line 7"
              x2="283.839"
              transform="translate(84.921 52.671)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <rect
              id="Rectangle_12"
              data-name="Rectangle 12"
              width="77.411"
              height="11.331"
              rx="5.666"
              transform="translate(254.569 93.669)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <rect
              id="Rectangle_13"
              data-name="Rectangle 13"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(239.742 125.104)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <rect
              id="Rectangle_14"
              data-name="Rectangle 14"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(239.742 149.96)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <rect
              id="Rectangle_15"
              data-name="Rectangle 15"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(239.742 174.817)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <rect
              id="Rectangle_16"
              data-name="Rectangle 16"
              width="77.411"
              height="11.331"
              rx="5.666"
              transform="translate(258.421 90.013)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <rect
              id="Rectangle_17"
              data-name="Rectangle 17"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(243.593 121.449)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <rect
              id="Rectangle_18"
              data-name="Rectangle 18"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(243.593 146.305)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <rect
              id="Rectangle_19"
              data-name="Rectangle 19"
              width="107.065"
              height="9.138"
              rx="4.569"
              transform="translate(243.593 171.161)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <ellipse
              id="Ellipse_43"
              data-name="Ellipse 43"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(100.711 40.666)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <ellipse
              id="Ellipse_44"
              data-name="Ellipse 44"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(116.886 40.666)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <ellipse
              id="Ellipse_45"
              data-name="Ellipse 45"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(133.062 40.666)"
              fill="#6c63ff"
              opacity="0.3"
            />
            <ellipse
              id="Ellipse_46"
              data-name="Ellipse 46"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(103.022 38.473)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <ellipse
              id="Ellipse_47"
              data-name="Ellipse 47"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(119.197 38.473)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <ellipse
              id="Ellipse_48"
              data-name="Ellipse 48"
              cx="5.777"
              cy="5.483"
              rx="5.777"
              ry="5.483"
              transform="translate(135.372 38.473)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_85"
              data-name="Path 85"
              d="M514.278,590.344a51.784,51.784,0,0,1-.9-14.022s-4.891-20.392-8.739-22.294h0c-.059.072-1.926,2.4-2.163,9.586a28.394,28.394,0,0,1-2.965,12.1s.882,9.1.378,14.631Z"
              transform="translate(-339.679 -380.436)"
              fill="#6c63ff"
            />
            <path
              id="Path_86"
              data-name="Path 86"
              d="M473.91,298.379H385.155a8.931,8.931,0,0,0-9.155,8.69V419.453a8.931,8.931,0,0,0,9.155,8.689h31.139c-1.04-4.094-2.333-10.487-1.023-14.933v0c.061-.207.126-.412.2-.611a22.084,22.084,0,0,0,.883-8.9,17.58,17.58,0,0,0,0-7.761c-.962-4.26-1.635-8.446-1.635-8.446a51.817,51.817,0,0,1-.067-9.081c.01-.076.022-.148.033-.221l-.255-.056s1.363-5.859,1.844-9.587c.114-.88.263-2,.425-3.186a8.415,8.415,0,0,1-1.307-.314c-4.329-1.446-5.692-14.533-5.692-14.533v-4.147s-1.443-6.353,3.607-9.168a59.959,59.959,0,0,1,6.942-3.5c.037-.025.073-.048.111-.076a4.08,4.08,0,0,0,1.267-1.548q.01-.157,0-.311c-.082-1.486-1.172-2.838-2.207-4.018l-2.647-3.018a2.931,2.931,0,0,1-.682-1.047,2.3,2.3,0,0,1-.072-.659q0-.123,0-.246.022-1.125.064-2.25c.025-.655.2-1.482.875-1.616.352-.07.817.052,1-.24a.546.546,0,0,0,.045-.388c0,.01,0,.02-.006.029l-.007-.036a7.815,7.815,0,0,1-.251-1.6,2.036,2.036,0,0,1,.109-.72c.392-1.088,1.74-1.534,2.931-1.739s2.529-.382,3.277-1.286a9.878,9.878,0,0,1,.65-.868,2.607,2.607,0,0,1,1.219-.584,7.072,7.072,0,0,1,4.431.373,4.053,4.053,0,0,0,1.787.548,19.139,19.139,0,0,0,1.866-.585,2.678,2.678,0,0,1,2.564,1.454,3.455,3.455,0,0,1,.475,1.836,2.453,2.453,0,0,1-.679,1.733c-.451.454-1.123.765-1.31,1.363-.076.243-.059.505-.126.751-.008.031-.022.059-.033.089l.038.045a7.444,7.444,0,0,1,1.29,7.009,7.973,7.973,0,0,1-5.269,5.061c0,.077-.006.154-.006.231a3.267,3.267,0,0,0,1.094,2.582l7.143,2.78s4.3-.495,5.852,5.6a10.018,10.018,0,0,1,.266,3.091,8.836,8.836,0,0,0,1.177,4.628c1.764,3.348,1.363,11.033-2.245,11.793-3.417.721-4.746.418-4.877.384l-.008.135c.056,1.442.6,13.879,2.56,15.384.543.416.439.7-.006.887h0s0,.08.012.224c.059.91.362,4.373,1.676,6.345,1.524,2.283,1.364,15.446,1.364,15.446l1.041,7.761s-.641,4.793,0,5.63c.364.474.805,7.824,1.119,14.1H473.91a8.931,8.931,0,0,0,9.155-8.689V307.068a8.931,8.931,0,0,0-9.155-8.689Z"
              transform="translate(-263.735 -218.235)"
              fill="#6c63ff"
            />
            <rect
              id="Rectangle_20"
              data-name="Rectangle 20"
              width="107.065"
              height="129.764"
              rx="23.772"
              transform="translate(103.022 70.275)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_87"
              data-name="Path 87"
              d="M178.058,400.023s-3.591-1.008-4.361.089,1.05,9.046,1.05,9.046l7.913.456L179.9,403Z"
              transform="translate(-139.228 -282.457)"
              fill="#2f2e41"
            />
            <path
              id="Path_88"
              data-name="Path 88"
              d="M103.8,579.347s7.2,15,1.655,14.531-7.7-14.531-7.7-14.531Z"
              transform="translate(-92.652 -396.501)"
              fill="#a0616a"
            />
            <path
              id="Path_89"
              data-name="Path 89"
              d="M234.209,572.661s-3.159,16.21,2.1,14.479,3.761-15.867,3.761-15.867Z"
              transform="translate(-175.974 -391.378)"
              fill="#a0616a"
            />
            <path
              id="Path_90"
              data-name="Path 90"
              d="M156.507,385.694s-.083,7.54,2.979,7.933-1.738,4.4-1.738,4.4l-5.462,1.021-7.862-.55-3.476-4.241s6.124-2.749,3.476-11.311Z"
              transform="translate(-119.209 -271.89)"
              fill="#a0616a"
            />
            <path
              id="Path_91"
              data-name="Path 91"
              d="M156.507,385.694s-.083,7.54,2.979,7.933-1.738,4.4-1.738,4.4l-5.462,1.021-7.862-.55-3.476-4.241s6.124-2.749,3.476-11.311Z"
              transform="translate(-119.209 -271.89)"
              opacity="0.1"
            />
            <path
              id="Path_92"
              data-name="Path 92"
              d="M161.15,564.926s3.89,7.933.828,32.832c0,0,.91,8.8.166,10.447s-6.869,24.035-6.869,24.035-7.862,1.65-8.938-3.3c0,0,1.076-7.069.993-8.169s1.738-13.117,1.738-13.117l-3.724-23.25-2.814,20.972s0,6.048-.91,7.383,0,28.2,0,28.2,2.565,4.084-1.324,4.163-7.365-.079-7.7-2.671-.5-5.184-1.324-6.755-1.9-19.558-1.655-25.842-5.462-38.566-3.641-41.944S161.15,564.926,161.15,564.926Z"
              transform="translate(-109.783 -387.342)"
              fill="#2f2e41"
            />
            <ellipse
              id="Ellipse_49"
              data-name="Ellipse 49"
              cx="9.931"
              cy="9.425"
              rx="9.931"
              ry="9.425"
              transform="translate(23.147 97.781)"
              fill="#a0616a"
            />
            <path
              id="Path_93"
              data-name="Path 93"
              d="M136.41,409.681s6.041,4.241,14.813.864c0,0,2.9-1.335,2.648-3.377s6.041,16.416,6.041,16.416l6.372,32.125-.331,13.117s-2.814-1.335-11.586,1.649-23.089-3.378-23.089-3.378l.5-33.7.5-19.636,1.324-4.32S134.259,408.268,136.41,409.681Z"
              transform="translate(-113.263 -287.158)"
              fill="#f2f2f2"
            />
            <path
              id="Path_94"
              data-name="Path 94"
              d="M182.063,399.881s1.462-.225,2.869,1.9,4.717,3.456,4.717,3.456,8.027.471,9.186,4.556,4.055,9.661,5.462,19.951,4.221,26.706,4.634,28.041-.579,5.42.579,6.676-8.193,1.257-8.193,1.257-.828-6.441-1.407-6.441-.414,4.32.166,7.462-4.221,0-4.221,0-3.724-14.374-7.283-27.334-5.627-20.108-4.965-23.014,2.483-11.232,1.159-12.017S182.063,399.881,182.063,399.881Z"
              transform="translate(-144.489 -282.631)"
              fill="#2f2e41"
            />
            <path
              id="Path_95"
              data-name="Path 95"
              d="M113.249,399.874s-2.162,1.117-7.624,4.808-9.186,6.519-9.186,6.519-2.152,1.571-3.476,10.918-4.3,33.539-3.145,36.6,1.572,4.87,1.159,6.676,8.689,1.728,8.855,1.335-.248-7.54.166-7.7,2.648,4.241,3.062,7.933,5.214,6.6,6.29,6.6,6.621-21.286,6.7-35.817-1.821-26.784-3.228-28.512S113.249,399.874,113.249,399.874Z"
              transform="translate(-87.609 -282.631)"
              fill="#2f2e41"
            />
            <path
              id="Path_96"
              data-name="Path 96"
              d="M177.113,735.707s.662-1.728,2.979-1.178a4.11,4.11,0,0,0,3.89-1.414s1.241-.157.414,1.335-1.49,2.513-1.49,2.513,4.965,10.761,1.738,13.353a7.231,7.231,0,0,1-6.952,1.021s-3.641-2.435-3.476-8.876a13.873,13.873,0,0,0-2.152-5.341c-1.986-3.3-3.476-8.326-1.076-9.268a13.513,13.513,0,0,1,3.018-.978s-1.123,4.875,1.778,6.579Z"
              transform="translate(-136.918 -490.102)"
              fill="#3f3d56"
            />
            <path
              id="Path_97"
              data-name="Path 97"
              d="M145.048,777.032s-1.986-3.535,1.324-3.927,6.869-.628,6.7,1.021-.579,4.163-.579,4.163l.579,1.807s.166,4.477.745,5.027,3.724,5.263-2.979,5.263-8.689-.707-8.11-2.2.745-8.876.745-8.876Z"
              transform="translate(-120.246 -519.253)"
              fill="#3f3d56"
            />
            <path
              id="Path_98"
              data-name="Path 98"
              d="M140.508,339.442s4.634,1.178,7.034,1.649,2.152-.864,2.152-.864,3.145.393,2.979.079,1.324-1.964-.414-3.849-1.241-3.3-1.241-3.3h-1.49l-.414-.55H146.8s-1.738-.628-6.29,0-10.758.785-11.255,3.377-3.062,5.812-2.152,7.3,6.124,7.619,6.621,10.211,2.815,3.168,2.732,1.545-2.4-7.279-.414-7.514S141.419,342.505,140.508,339.442Z"
              transform="translate(-110.576 -239.776)"
              fill="#2f2e41"
            />
            <path
              id="Path_99"
              data-name="Path 99"
              d="M1006.141,86.584a8.847,8.847,0,0,0-7.629,5.063c-1.908,4.377.549,9.518,4.236,12.71s8.424,5.016,12.728,7.414c5.781,3.221,10.975,7.692,13.867,13.431s3.2,12.848-.2,18.331c-3.156,5.089-8.894,8.135-14.366,10.944"
              transform="translate(-646.093 -83.858)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <ellipse
              id="Ellipse_50"
              data-name="Ellipse 50"
              cx="7"
              cy="3"
              rx="7"
              ry="3"
              transform="translate(358)"
              fill="#6c63ff"
            />
            <ellipse
              id="Ellipse_51"
              data-name="Ellipse 51"
              cx="6.5"
              cy="3.5"
              rx="6.5"
              ry="3.5"
              transform="translate(364 20)"
              fill="#6c63ff"
            />
            <ellipse
              id="Ellipse_52"
              data-name="Ellipse 52"
              cx="7"
              cy="3"
              rx="7"
              ry="3"
              transform="translate(351 24)"
              fill="#6c63ff"
            />
            <ellipse
              id="Ellipse_53"
              data-name="Ellipse 53"
              cx="7"
              cy="3"
              rx="7"
              ry="3"
              transform="translate(370 41)"
              fill="#6c63ff"
            />
            <ellipse
              id="Ellipse_54"
              data-name="Ellipse 54"
              cx="6.5"
              cy="3"
              rx="6.5"
              ry="3"
              transform="translate(384 41)"
              fill="#6c63ff"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default PlayerRepImg;
